// ─── Screen registry ──────────────────────────────────────────────────────────

type ScreenId = 'entry' | 'join' | 'lobby' | 'instruction' | 'playing' | 'waiting' | 'results' | 'session-end' | 'leaderboard' | 'profile';

interface Screen {
  mount:   () => void;
  unmount: () => void;
}

const registry = new Map<ScreenId, Screen>();
let currentScreen: ScreenId | null = null;
let currentUnmount: (() => void) | null = null;

// ─── Registration ─────────────────────────────────────────────────────────────

export function registerScreen(id: ScreenId, screen: Screen): void {
  registry.set(id, screen);
}

// ─── Navigation ───────────────────────────────────────────────────────────────

export function navigateTo(id: ScreenId): void {
  if (id === currentScreen) return;

  // Unmount current
  if (currentUnmount) {
    currentUnmount();
    currentUnmount = null;
  }

  // Hide all screens
  document.querySelectorAll<HTMLElement>('.screen').forEach(el => {
    el.style.display = 'none';
  });

  // Show target screen
  const el = document.getElementById(`screen-${id}`);
  if (el) el.style.display = 'flex';

  // Mount new screen
  const screen = registry.get(id);
  if (screen) {
    screen.mount();
    currentUnmount = screen.unmount;
  }

  currentScreen = id;
}

// ─── Back button (Android Capacitor) ─────────────────────────────────────────

const backStack: ScreenId[] = [];

export function pushHistory(id: ScreenId): void {
  backStack.push(id);
}

export function goBack(): boolean {
  if (backStack.length <= 1) return false;
  backStack.pop();
  const prev = backStack[backStack.length - 1];
  if (prev) navigateTo(prev);
  return true;
}
